// Utility function to handle image URLs
// After Cloudinary integration, new images will have Cloudinary URLs
// This function handles both old local paths and new Cloudinary URLs

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export const fixImageUrl = (url) => {
  if (!url) return null;
  
  // If it's a Cloudinary URL (res.cloudinary.com), return as-is
  if (url.includes('res.cloudinary.com')) {
    return url;
  }
  
  // If it's any other external URL (unsplash, etc.), return as-is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // For old local paths (legacy data), try to construct URL
  // These will likely be broken until images are re-uploaded to Cloudinary
  if (url.startsWith('/uploads/')) {
    return `${BACKEND_URL}/api/uploads/${url.substring(9)}`;
  }
  
  if (url.startsWith('/api/uploads/')) {
    return `${BACKEND_URL}${url}`;
  }
  
  // For any other relative path
  return `${BACKEND_URL}${url}`;
};

export const fixImageUrls = (images) => {
  if (!images || !Array.isArray(images)) return [];
  return images.map(fixImageUrl).filter(Boolean);
};
